import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  uploadedImage: null, // Base64 图片数据
  uploadedImagePreview: null, // 预览URL
  selectedSourceMeta: null, // 选择来源的结构化信息
  selectedStyle: null, // { id, name, thumbnail }
  generationRequestId: 0,
  resetVersion: 0,
  generateStatus: 'idle', // 'idle' | 'loading' | 'success' | 'error'
  resultImage: null, // 生成结果图片URL
  progress: 0, // 生成进度 0-100
  errorMessage: null,
}

const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    setUploadedImage: (state, action) => {
      state.generationRequestId += 1
      state.uploadedImage = action.payload.base64
      state.uploadedImagePreview = action.payload.preview
      state.selectedSourceMeta = action.payload.meta || null
      state.generateStatus = 'idle'
      state.resultImage = null
      state.progress = 0
      state.errorMessage = null
    },
    setSelectedStyle: (state, action) => {
      state.generationRequestId += 1
      state.selectedStyle = action.payload
      state.generateStatus = 'idle'
      state.resultImage = null
      state.progress = 0
      state.errorMessage = null
    },
    setGenerateStatus: (state, action) => {
      state.generateStatus = action.payload
    },
    setResultImage: (state, action) => {
      state.resultImage = action.payload
    },
    setProgress: (state, action) => {
      state.progress = action.payload
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload
    },
    resetGenerationState: (state) => {
      state.generationRequestId += 1
      state.generateStatus = 'idle'
      state.resultImage = null
      state.progress = 0
      state.errorMessage = null
    },
    resetImageState: (state) => {
      return {
        ...initialState,
        generationRequestId: state.generationRequestId + 1,
        resetVersion: state.resetVersion + 1,
      }
    },
    startGeneration: (state) => {
      state.generationRequestId += 1
      state.generateStatus = 'loading'
      state.resultImage = null
      state.progress = 0
      state.errorMessage = null
    },
    generationSuccess: (state, action) => {
      const requestId = action.payload?.requestId

      if (requestId != null && requestId !== state.generationRequestId) {
        return
      }

      state.generateStatus = 'success'
      state.resultImage = action.payload?.resultUrl ?? action.payload
      state.progress = 100
    },
    generationError: (state, action) => {
      const requestId = action.payload?.requestId

      if (requestId != null && requestId !== state.generationRequestId) {
        return
      }

      state.generateStatus = 'error'
      state.errorMessage = action.payload?.message ?? action.payload
      state.progress = 0
    },
  },
})

export const {
  setUploadedImage,
  setSelectedStyle,
  setGenerateStatus,
  setResultImage,
  setProgress,
  setErrorMessage,
  resetGenerationState,
  resetImageState,
  startGeneration,
  generationSuccess,
  generationError,
} = imageSlice.actions

export default imageSlice.reducer
